import { Badge, Box, Group, Tooltip, Skeleton } from "@mantine/core"
import { SourceIcon } from "../../../../utils/SourceIcon";

const NewRequestsCell: React.FC<any> = ({ data}:{data: any}) => {

  const newCount = data?.aggregations?.requests?.new || 0;

  return (
    <Group spacing="xs" noWrap ml={39}>
      {newCount > 0 && (
        <Tooltip
          position="bottom"
          sx={{ fontSize: 12 }}
          label={`${newCount} new evidences`}
        >
          <Badge variant="dot">{newCount}</Badge>
        </Tooltip>
      )}
      {/* Additional content can be added here */}
      {/*  {origin && (
        <Tooltip
          position="bottom"
          sx={{ fontSize: 12 }}
          label={`${origin} sync - ${originId}`}
        >
          <Box mb={-2} p={0}>
            <SourceIcon sourceName={origin} width={16} height={16} />
          </Box>
        </Tooltip>
      )} */}
    </Group>
  )
}

// Skeleton component for NewRequestsCell
export const NewRequestsCellSkeleton: React.FC<{ col: any }> = ({ col }) => {
  const columnWidth = col.width;
  const minWidth = col.minWidth;
  const maxWidth = col.maxWidth;
  
  // New requests typically show badge-style content
  const width = columnWidth ? Math.min(parseInt(columnWidth) * 0.6, 60) : 40;
  
  return (
    <Box 
      sx={{ 
        width: columnWidth || "100%", 
        minWidth, 
        maxWidth,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Skeleton 
        height={20} 
        width={width} 
        radius="xl" 
        sx={{ 
          backgroundColor: '#f8f9fa',
          border: '1px solid #e9ecef'
        }} 
      />
    </Box>
  );
};

export default NewRequestsCell